import script from "./AdminConsumerAddView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminConsumerAddView.vue?vue&type=script&setup=true&lang=js"

import "./AdminConsumerAddView.vue?vue&type=style&index=0&id=285a2562&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-285a2562"]])

export default __exports__